<template>
  <div>
    <Skeleton height="1rem" v-if="appStore.initial"></Skeleton>
    <p class="chat-widget__footer-info" v-else v-html="infoText"></p>
  </div>
</template>
<script setup>
import {useAppStateStore} from "@/modules/chat/stores/appStore";
import {computed} from "vue";
import {MODE_IMAGE, MODE_MUSIC, MODE_TEXT, MODE_UML} from "@/constants";
import Skeleton from "primevue/skeleton";

const appStore = useAppStateStore();

const infoText = computed(() => {
  if (appStore.mode === MODE_TEXT) {
    const postFix = appStore.canWebSearch() ? 'WEB-поиск добавляет в контекст текущего запроса данные из интернета (5 результатов, увеличивает потребление токенов).': '';
    return `Цены указаны за 1000 токенов, ~3000 символов, ~1-3 содержательных запроса. Задать модель по умолчанию можно в <a href="/lk/profile">персональных настройках</a>.${postFix}`;
  }
  if (appStore.mode === MODE_IMAGE) {
    return 'Одна генерация MidJourney выводит сразу несколько вариантов (4 изображения, 3 ₽ за 1 изображение). В случае ошибки при запросе баланс не списывается.'
  }
  if (appStore.mode === MODE_UML) {
    return 'Стоимость одной генерации: 15 ₽. Отвечает только на последний вопрос (без контекста диалога). В случае ошибки при запросе баланс не списывается.'
  }
  if (appStore.mode === MODE_MUSIC) {
    return 'В соответствии с политикой Suno права на треки принадлежат вам. Отвечает только на последний вопрос (без контекста диалога). В случае ошибки при запросе баланс не списывается.'
  }
  return '';
});
</script>